"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextOr = exports.SubmitButtton = exports.StyledForm = exports.SocialWrapper = exports.SocialButtton = exports.Separator = exports.LegalNotice = exports.IconWrapper = exports.IconText = exports.HiddenInput = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const StyledForm = exports.StyledForm = (0, _mui.styled)('form')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  marginTop: theme.spacing(8)
}));
const SubmitButtton = exports.SubmitButtton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  minWidth: '330px',
  marginTop: theme.spacing(3),
  order: 8
}));
const SocialWrapper = exports.SocialWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  marginTop: theme.spacing(1)
}));
const IconWrapper = exports.IconWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '40px'
}));
const IconText = exports.IconText = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  paddingLeft: theme.spacing(10),
  textAlign: 'left',
  fontWeight: 'bold'
}));

// this is custom component by design
const SocialButtton = exports.SocialButtton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'start',
  width: '100%',
  minWidth: '330px',
  maxWidth: '500px',
  height: 'auto',
  minHeight: '40px',
  marginTop: theme.spacing(2),
  textTransform: 'none',
  padding: '5px 10px'
}));
const Separator = exports.Separator = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(5),
  marginBottom: theme.spacing(2)
}));
const HiddenInput = exports.HiddenInput = (0, _mui.styled)('input')(({
  theme
}) => ({
  display: 'none'
}));
const LegalNotice = exports.LegalNotice = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: 'flex',
  marginInline: 'auto',
  marginBottom: theme.spacing(3),
  maxWidth: '500px'
}));
const TextOr = exports.TextOr = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  fontSize: '1.4rem',
  textTransform: 'uppercase'
}));